import cookies from '../storage/cookies';
interface CustomFields {
    last_order_city?: string;
    last_order_store_id?: string;
    typed_name?: string;
    latest_language?: string;
    nps?: string
}
interface InsiderUserObj {
    type: 'user';
    value: {
        uuid?: string;
        language: string;
        custom: CustomFields;
    };
}

export const getInsiderUserObject = (customFields?: CustomFields, uuidParam?: string) => {
    const currentLanguage = document.documentElement.lang;
    const userObj: InsiderUserObj = {
        type: 'user',
        value: {
            language: currentLanguage?.replace('-', '_'),
            custom: {
                latest_language: currentLanguage?.split('-')[0] || ""
            }
        }
    };

    const uuid = cookies.read('cuhe');

    if (uuidParam || uuid) {
        userObj.value.uuid = uuid || uuidParam;
    }

    if (customFields) {
        userObj.value.custom = {...userObj.value.custom, ...customFields}
    }

    return userObj;
};
